export default __webpack_public_path__ + "6d4619e18766eb7685d61b58d40849d9.jpg";